export default __webpack_public_path__ + "static/cole-d67e24bcb247553fd6e0ab4d298f105a.jpg";